<template>
  <div>
    <b-button
      variant="outline-primary"
      size="md"
      class="my-2 my-md-0"
      @click="handleOpenFormSideBar"
    >
      Add Task
      <b-icon icon="plus-circle-fill" aria-hidden="true" />
    </b-button>
    <b-sidebar
      :id="sbId"
      :visible="formSBModel"
      sidebar-class="border-right border-danger"
      right
      shadow
      lazy
      :no-header="true"
    >
      <b-card :title="titleDate" style="height:100vh">
        <!-- BTN -- CASE NUMBER, URLS (OPT)-->
        <!-- TITLE (REQ)-->
        <b-form-group
          id="input-group-1"
          label="Title:"
          label-for="input-1"
          description="What needs to be done?"
        >
          <b-form-input
            id="input-1"
            v-model="form.title"
            type="text"
            placeholder="Pick up Ensure "
            required
          />
        </b-form-group>

        <!--REMINDER -->
        <div class="optional2">
          <div
            :class="`toggler  ${form.hasReminder ? 'bg' : ''}`"
            @click="handleToggleHasReminder"
          >
            <div :class="`slider ${form.hasReminder ? 'btns' : ''}`" />
          </div>
          <p>
            Set a reminder?
            <span id="popover-target-1">
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.00001 12.0003C8.3682 12.0003 8.66668 11.7018 8.66668 11.3337C8.66668 10.9655 8.3682 10.667 8.00001 10.667C7.63182 10.667 7.33334 10.9655 7.33334 11.3337C7.33334 11.7018 7.63182 12.0003 8.00001 12.0003Z"
                  fill="#B3C2CB"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M8.23738 5.70689C7.91366 5.7211 7.74104 5.85135 7.68129 5.97831C7.5245 6.31145 7.12733 6.45441 6.79419 6.29762C6.46106 6.14083 6.3181 5.74366 6.47489 5.41053C6.82301 4.67086 7.57297 4.40144 8.17892 4.37484C8.7618 4.34926 9.48718 4.53492 9.88849 5.05823C10.1973 5.46093 10.3708 5.9714 10.3007 6.50813C10.2297 7.05237 9.91926 7.54056 9.41556 7.91111C8.74294 8.40594 8.74413 8.65841 8.74431 8.69517C8.74431 8.69571 8.74431 8.6962 8.74431 8.69664C8.74431 9.06483 8.44583 9.36331 8.07764 9.36331C7.70945 9.36331 7.41098 9.06483 7.41098 8.69664C7.41098 8.05884 7.78196 7.45763 8.62545 6.8371C8.88471 6.64637 8.96187 6.46388 8.97862 6.33555C8.99635 6.19971 8.95784 6.03573 8.83044 5.8696C8.82148 5.85791 8.77279 5.80928 8.65086 5.76547C8.53445 5.72363 8.38807 5.70028 8.23738 5.70689Z"
                  fill="#B3C2CB"
                />
                <path
                  d="M8 15.3337C3.93334 15.3337 0.666672 12.067 0.666672 8.00033C0.666672 3.93366 3.93334 0.666992 8 0.666992C12.0667 0.666992 15.3333 3.93366 15.3333 8.00033C15.3333 12.067 12.0667 15.3337 8 15.3337ZM8 2.00033C4.66667 2.00033 2.00001 4.66699 2.00001 8.00033C2.00001 11.3337 4.66667 14.0003 8 14.0003C11.3333 14.0003 14 11.3337 14 8.00033C14 4.66699 11.3333 2.00033 8 2.00033Z"
                  fill="#B3C2CB"
                />
              </svg>
            </span>
            <b-popover
              target="popover-target-1"
              id="popover-target-2"
              triggers="click"
              placement="bottom"
              class="info_popup"
            >
              Shall you we reminded about this? [Premium]
            </b-popover>
          </p>
        </div>
        <!--- FAMILY -->
        <b-form-group
          id="fieldset-2"
          label="Get the help you need:"
          description="Tap a member above to assign/un-assign"
          label-for="input-1"
        >
          <div class="optional2">
            <div
              :class="`toggler  ${form.needVolunteer ? 'bg' : ''}`"
              @click="handleToggleNeedAVolunteer"
            >
              <div :class="`slider ${form.needVolunteer ? 'btns' : ''}`" />
            </div>
            <p>
              {{ form.needVolunteer ? "Need a Volunteer" : "Assign" }}
              <span id="popover-target-1">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8.00001 12.0003C8.3682 12.0003 8.66668 11.7018 8.66668 11.3337C8.66668 10.9655 8.3682 10.667 8.00001 10.667C7.63182 10.667 7.33334 10.9655 7.33334 11.3337C7.33334 11.7018 7.63182 12.0003 8.00001 12.0003Z"
                    fill="#B3C2CB"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M8.23738 5.70689C7.91366 5.7211 7.74104 5.85135 7.68129 5.97831C7.5245 6.31145 7.12733 6.45441 6.79419 6.29762C6.46106 6.14083 6.3181 5.74366 6.47489 5.41053C6.82301 4.67086 7.57297 4.40144 8.17892 4.37484C8.7618 4.34926 9.48718 4.53492 9.88849 5.05823C10.1973 5.46093 10.3708 5.9714 10.3007 6.50813C10.2297 7.05237 9.91926 7.54056 9.41556 7.91111C8.74294 8.40594 8.74413 8.65841 8.74431 8.69517C8.74431 8.69571 8.74431 8.6962 8.74431 8.69664C8.74431 9.06483 8.44583 9.36331 8.07764 9.36331C7.70945 9.36331 7.41098 9.06483 7.41098 8.69664C7.41098 8.05884 7.78196 7.45763 8.62545 6.8371C8.88471 6.64637 8.96187 6.46388 8.97862 6.33555C8.99635 6.19971 8.95784 6.03573 8.83044 5.8696C8.82148 5.85791 8.77279 5.80928 8.65086 5.76547C8.53445 5.72363 8.38807 5.70028 8.23738 5.70689Z"
                    fill="#B3C2CB"
                  />
                  <path
                    d="M8 15.3337C3.93334 15.3337 0.666672 12.067 0.666672 8.00033C0.666672 3.93366 3.93334 0.666992 8 0.666992C12.0667 0.666992 15.3333 3.93366 15.3333 8.00033C15.3333 12.067 12.0667 15.3337 8 15.3337ZM8 2.00033C4.66667 2.00033 2.00001 4.66699 2.00001 8.00033C2.00001 11.3337 4.66667 14.0003 8 14.0003C11.3333 14.0003 14 11.3337 14 8.00033C14 4.66699 11.3333 2.00033 8 2.00033Z"
                    fill="#B3C2CB"
                  />
                </svg>
              </span>
              <b-popover
                target="popover-target-1"
                id="popover-target-2"
                triggers="click"
                placement="bottom"
                class="info_popup"
              >
                Assign or leave open let everyone know you need a volunteer
              </b-popover>
            </p>
          </div>
          <div :class="form.needVolunteer ? 'family-opacity' : ''" class="mb-4">
            <b-avatar
              variant="primary"
              :src="profile.imgURL"
              text="BV"
              style="margin-right: 5px"
              v-b-tooltip=""
            />
            <b-avatar
              v-for="(aMember, j) in familyActive"
              variant="primary"
              :src="aMember.imgURL"
              text="BV"
              style="margin-right: 5px"
              v-b-tooltip=""
              :key="j"
            />
          </div>
        </b-form-group>

        <!-- DESCRIPTION (OPT)-->
        <b-form-group
          id="input-group-1"
          label="Description"
          label-for="input-1"
          style="margin-top: 25px;"
          description="Freely write. Call Log will identify the case # and phone number in your notes."
        >
          <transition name="fadeHeight" mode="out-in">
            <editor
              id="textarea-default"
              v-show="form"
              @input="input"
              :clear="clear"
              :content="form.description"
              @resetClear="resetClear"
            />
          </transition>
        </b-form-group>

        <!-- PRIORITY LEVEL (OPT)-->
        <b-form-group id="input-group-1" label-for="input-1">
          <!-- CALL PRIORITY-->
          <b-form-group v-slot="{ ariaDescribedby }">
            <label id="popover-target-priority">
              Priority
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.00001 12.0003C8.3682 12.0003 8.66668 11.7018 8.66668 11.3337C8.66668 10.9655 8.3682 10.667 8.00001 10.667C7.63182 10.667 7.33334 10.9655 7.33334 11.3337C7.33334 11.7018 7.63182 12.0003 8.00001 12.0003Z"
                  fill="#B3C2CB"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M8.23738 5.70689C7.91366 5.7211 7.74104 5.85135 7.68129 5.97831C7.5245 6.31145 7.12733 6.45441 6.79419 6.29762C6.46106 6.14083 6.3181 5.74366 6.47489 5.41053C6.82301 4.67086 7.57297 4.40144 8.17892 4.37484C8.7618 4.34926 9.48718 4.53492 9.88849 5.05823C10.1973 5.46093 10.3708 5.9714 10.3007 6.50813C10.2297 7.05237 9.91926 7.54056 9.41556 7.91111C8.74294 8.40594 8.74413 8.65841 8.74431 8.69517C8.74431 8.69571 8.74431 8.6962 8.74431 8.69664C8.74431 9.06483 8.44583 9.36331 8.07764 9.36331C7.70945 9.36331 7.41098 9.06483 7.41098 8.69664C7.41098 8.05884 7.78196 7.45763 8.62545 6.8371C8.88471 6.64637 8.96187 6.46388 8.97862 6.33555C8.99635 6.19971 8.95784 6.03573 8.83044 5.8696C8.82148 5.85791 8.77279 5.80928 8.65086 5.76547C8.53445 5.72363 8.38807 5.70028 8.23738 5.70689Z"
                  fill="#B3C2CB"
                />
                <path
                  d="M8 15.3337C3.93334 15.3337 0.666672 12.067 0.666672 8.00033C0.666672 3.93366 3.93334 0.666992 8 0.666992C12.0667 0.666992 15.3333 3.93366 15.3333 8.00033C15.3333 12.067 12.0667 15.3337 8 15.3337ZM8 2.00033C4.66667 2.00033 2.00001 4.66699 2.00001 8.00033C2.00001 11.3337 4.66667 14.0003 8 14.0003C11.3333 14.0003 14 11.3337 14 8.00033C14 4.66699 11.3333 2.00033 8 2.00033Z"
                  fill="#B3C2CB"
                />
              </svg>
            </label>
            <b-popover
              id="popover-target-2"
              target="popover-call-priority"
              triggers="hover"
              placement="top"
              class="info_popup"
            >
              An indication of the call's importance or urgency.
            </b-popover>
            <b-form-radio-group
              id="btn-radios-2"
              v-model="form.priority"
              :options="priorityOpt"
              :aria-describedby="ariaDescribedby"
              button-variant="outline-warning"
              size="md"
              name="radio-btn-outline"
              buttons
            ></b-form-radio-group>
          </b-form-group>
        </b-form-group>

        <!-- TASK SIZE (REQ)-->
        <b-form-group id="input-group-1" label-for="input-1">
          <label id="popover-target-priority">
            Size
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8.00001 12.0003C8.3682 12.0003 8.66668 11.7018 8.66668 11.3337C8.66668 10.9655 8.3682 10.667 8.00001 10.667C7.63182 10.667 7.33334 10.9655 7.33334 11.3337C7.33334 11.7018 7.63182 12.0003 8.00001 12.0003Z"
                fill="#B3C2CB"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M8.23738 5.70689C7.91366 5.7211 7.74104 5.85135 7.68129 5.97831C7.5245 6.31145 7.12733 6.45441 6.79419 6.29762C6.46106 6.14083 6.3181 5.74366 6.47489 5.41053C6.82301 4.67086 7.57297 4.40144 8.17892 4.37484C8.7618 4.34926 9.48718 4.53492 9.88849 5.05823C10.1973 5.46093 10.3708 5.9714 10.3007 6.50813C10.2297 7.05237 9.91926 7.54056 9.41556 7.91111C8.74294 8.40594 8.74413 8.65841 8.74431 8.69517C8.74431 8.69571 8.74431 8.6962 8.74431 8.69664C8.74431 9.06483 8.44583 9.36331 8.07764 9.36331C7.70945 9.36331 7.41098 9.06483 7.41098 8.69664C7.41098 8.05884 7.78196 7.45763 8.62545 6.8371C8.88471 6.64637 8.96187 6.46388 8.97862 6.33555C8.99635 6.19971 8.95784 6.03573 8.83044 5.8696C8.82148 5.85791 8.77279 5.80928 8.65086 5.76547C8.53445 5.72363 8.38807 5.70028 8.23738 5.70689Z"
                fill="#B3C2CB"
              />
              <path
                d="M8 15.3337C3.93334 15.3337 0.666672 12.067 0.666672 8.00033C0.666672 3.93366 3.93334 0.666992 8 0.666992C12.0667 0.666992 15.3333 3.93366 15.3333 8.00033C15.3333 12.067 12.0667 15.3337 8 15.3337ZM8 2.00033C4.66667 2.00033 2.00001 4.66699 2.00001 8.00033C2.00001 11.3337 4.66667 14.0003 8 14.0003C11.3333 14.0003 14 11.3337 14 8.00033C14 4.66699 11.3333 2.00033 8 2.00033Z"
                fill="#B3C2CB"
              />
            </svg>
          </label>
          <b-popover
            id="popover-target-2"
            target="popover-call-priority"
            triggers="hover"
            placement="top"
            class="info_popup"
          >
            How Big is the task?
          </b-popover>
          <b-form-radio-group
            id="btn-radios-2"
            v-model="form.size"
            :options="sizeOpt"
            :aria-describedby="ariaDescribedby"
            button-variant="outline-warning"
            size="md"
            name="radio-btn-outline"
            buttons
          ></b-form-radio-group>
        </b-form-group>

        <!-- CATEGORIES (REQ)-->
        <b-form-group id="input-group-1" label-for="input-1">
          <div class="col-md-12" id="tags">
            <label id="popover-target-priority">
              Add Tags
              <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
              >
                <path
                    d="M8.00001 12.0003C8.3682 12.0003 8.66668 11.7018 8.66668 11.3337C8.66668 10.9655 8.3682 10.667 8.00001 10.667C7.63182 10.667 7.33334 10.9655 7.33334 11.3337C7.33334 11.7018 7.63182 12.0003 8.00001 12.0003Z"
                    fill="#B3C2CB"
                />
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M8.23738 5.70689C7.91366 5.7211 7.74104 5.85135 7.68129 5.97831C7.5245 6.31145 7.12733 6.45441 6.79419 6.29762C6.46106 6.14083 6.3181 5.74366 6.47489 5.41053C6.82301 4.67086 7.57297 4.40144 8.17892 4.37484C8.7618 4.34926 9.48718 4.53492 9.88849 5.05823C10.1973 5.46093 10.3708 5.9714 10.3007 6.50813C10.2297 7.05237 9.91926 7.54056 9.41556 7.91111C8.74294 8.40594 8.74413 8.65841 8.74431 8.69517C8.74431 8.69571 8.74431 8.6962 8.74431 8.69664C8.74431 9.06483 8.44583 9.36331 8.07764 9.36331C7.70945 9.36331 7.41098 9.06483 7.41098 8.69664C7.41098 8.05884 7.78196 7.45763 8.62545 6.8371C8.88471 6.64637 8.96187 6.46388 8.97862 6.33555C8.99635 6.19971 8.95784 6.03573 8.83044 5.8696C8.82148 5.85791 8.77279 5.80928 8.65086 5.76547C8.53445 5.72363 8.38807 5.70028 8.23738 5.70689Z"
                    fill="#B3C2CB"
                />
                <path
                    d="M8 15.3337C3.93334 15.3337 0.666672 12.067 0.666672 8.00033C0.666672 3.93366 3.93334 0.666992 8 0.666992C12.0667 0.666992 15.3333 3.93366 15.3333 8.00033C15.3333 12.067 12.0667 15.3337 8 15.3337ZM8 2.00033C4.66667 2.00033 2.00001 4.66699 2.00001 8.00033C2.00001 11.3337 4.66667 14.0003 8 14.0003C11.3333 14.0003 14 11.3337 14 8.00033C14 4.66699 11.3333 2.00033 8 2.00033Z"
                    fill="#B3C2CB"
                />
              </svg>
            </label>
            <b-popover
                id="popover-target-2"
                target="popover-call-priority"
                triggers="hover"
                placement="top"
                class="info_popup"
            >
              An indication of the call's importance or urgency.
            </b-popover>
            <b-input-group class="mb-2 place-lived">
              <b-form-input
                  placeholder="Current Location"
                  class="input__place-lived"
                  v-model="formInputAddTag"
                  @keypress.enter.prevent="addTag(formInputAddTag)"
              />
            </b-input-group>
            <div class="form-group">
              <div class="places-lived">
                <div
                    class="place__places-lived"
                    v-for="(aTag, index) in form.tags"
                    :key="index"
                >
                    <span class="ico">
                      <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M12 2C8.13 2 5 5.13 5 9C5 14.25 12 22 12 22C12 22 19 14.25 19 9C19 5.13 15.87 2 12 2ZM7 9C7 6.24 9.24 4 12 4C14.76 4 17 6.24 17 9C17 11.88 14.12 16.19 12 18.88C9.92 16.21 7 11.85 7 9ZM9.5 9C9.5 7.61929 10.6193 6.5 12 6.5C12.8932 6.5 13.7185 6.9765 14.1651 7.75C14.6116 8.5235 14.6116 9.4765 14.1651 10.25C13.7185 11.0235 12.8932 11.5 12 11.5C10.6193 11.5 9.5 10.3807 9.5 9Z"
                            fill="#B3C2CB"
                        />
                      </svg>
                    </span>
                  {{ aTag }}
                  <span class="ico del__ico" @click="delTag(aTag)">
                      <svg
                          width="12"
                          height="12"
                          viewBox="0 0 12 12"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M1 3C1 2.72386 1.22386 2.5 1.5 2.5H10.5C10.7761 2.5 11 2.72386 11 3C11 3.27614 10.7761 3.5 10.5 3.5H1.5C1.22386 3.5 1 3.27614 1 3Z"
                            fill="#FF8C7D"
                        />
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M5 1.5C4.86739 1.5 4.74022 1.55268 4.64645 1.64645C4.55268 1.74021 4.5 1.86739 4.5 2V2.5H7.5V2C7.5 1.86739 7.44732 1.74021 7.35355 1.64645C7.25979 1.55268 7.13261 1.5 7 1.5H5ZM8.5 2.5V2C8.5 1.60217 8.34196 1.22064 8.06066 0.93934C7.77936 0.658035 7.39782 0.5 7 0.5H5C4.60218 0.5 4.22064 0.658035 3.93934 0.93934C3.65804 1.22064 3.5 1.60217 3.5 2V2.5H2.5C2.22386 2.5 2 2.72386 2 3V10C2 10.3978 2.15804 10.7794 2.43934 11.0607C2.72064 11.342 3.10217 11.5 3.5 11.5H8.5C8.89783 11.5 9.27936 11.342 9.56066 11.0607C9.84196 10.7794 10 10.3978 10 10V3C10 2.72386 9.77614 2.5 9.5 2.5H8.5ZM3 3.5V10C3 10.1326 3.05268 10.2598 3.14645 10.3536C3.24021 10.4473 3.36739 10.5 3.5 10.5H8.5C8.63261 10.5 8.75978 10.4473 8.85355 10.3536C8.94732 10.2598 9 10.1326 9 10V3.5H3Z"
                            fill="#FF8C7D"
                        />
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M5 5C5.27614 5 5.5 5.22386 5.5 5.5V8.5C5.5 8.77614 5.27614 9 5 9C4.72386 9 4.5 8.77614 4.5 8.5V5.5C4.5 5.22386 4.72386 5 5 5Z"
                            fill="#FF8C7D"
                        />
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M7 5C7.27614 5 7.5 5.22386 7.5 5.5V8.5C7.5 8.77614 7.27614 9 7 9C6.72386 9 6.5 8.77614 6.5 8.5V5.5C6.5 5.22386 6.72386 5 7 5Z"
                            fill="#FF8C7D"
                        />
                      </svg>
                    </span>
                </div>
              </div>
            </div>
          </div>
        </b-form-group>

        <!-- RECURRING (REQ)-->
        <b-form-group id="input-group-1" label="Recurring:" label-for="input-1">
          <div class="optional2">
            <div
              :class="`toggler  ${form.isRecurring ? 'bg' : ''}`"
              @click="handleToggleIsRecurring"
            >
              <div :class="`slider ${form.isRecurring ? 'btns' : ''}`" />
            </div>
            <p>
              Recurring?
              <span id="popover-target-1">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8.00001 12.0003C8.3682 12.0003 8.66668 11.7018 8.66668 11.3337C8.66668 10.9655 8.3682 10.667 8.00001 10.667C7.63182 10.667 7.33334 10.9655 7.33334 11.3337C7.33334 11.7018 7.63182 12.0003 8.00001 12.0003Z"
                    fill="#B3C2CB"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M8.23738 5.70689C7.91366 5.7211 7.74104 5.85135 7.68129 5.97831C7.5245 6.31145 7.12733 6.45441 6.79419 6.29762C6.46106 6.14083 6.3181 5.74366 6.47489 5.41053C6.82301 4.67086 7.57297 4.40144 8.17892 4.37484C8.7618 4.34926 9.48718 4.53492 9.88849 5.05823C10.1973 5.46093 10.3708 5.9714 10.3007 6.50813C10.2297 7.05237 9.91926 7.54056 9.41556 7.91111C8.74294 8.40594 8.74413 8.65841 8.74431 8.69517C8.74431 8.69571 8.74431 8.6962 8.74431 8.69664C8.74431 9.06483 8.44583 9.36331 8.07764 9.36331C7.70945 9.36331 7.41098 9.06483 7.41098 8.69664C7.41098 8.05884 7.78196 7.45763 8.62545 6.8371C8.88471 6.64637 8.96187 6.46388 8.97862 6.33555C8.99635 6.19971 8.95784 6.03573 8.83044 5.8696C8.82148 5.85791 8.77279 5.80928 8.65086 5.76547C8.53445 5.72363 8.38807 5.70028 8.23738 5.70689Z"
                    fill="#B3C2CB"
                  />
                  <path
                    d="M8 15.3337C3.93334 15.3337 0.666672 12.067 0.666672 8.00033C0.666672 3.93366 3.93334 0.666992 8 0.666992C12.0667 0.666992 15.3333 3.93366 15.3333 8.00033C15.3333 12.067 12.0667 15.3337 8 15.3337ZM8 2.00033C4.66667 2.00033 2.00001 4.66699 2.00001 8.00033C2.00001 11.3337 4.66667 14.0003 8 14.0003C11.3333 14.0003 14 11.3337 14 8.00033C14 4.66699 11.3333 2.00033 8 2.00033Z"
                    fill="#B3C2CB"
                  />
                </svg>
              </span>
              <b-popover
                target="popover-target-1"
                id="popover-target-2"
                triggers="click"
                placement="bottom"
                class="info_popup"
              >
                Is this a task that shall repeat? We score these differently
              </b-popover>
            </p>
          </div>
        </b-form-group>

        <!-- PRIVATE? (REQ)-->
        <b-form-group id="input-group-1" label="Private?:" label-for="input-1">
          <div class="optional2">
            <div
              :class="`toggler  ${form.isPrivate ? 'bg' : ''}`"
              @click="handleToggleIsPrivate"
            >
              <div :class="`slider ${form.isPrivate ? 'btns' : ''}`" />
            </div>
            <p>
              Private?
              <span id="popover-target-1">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8.00001 12.0003C8.3682 12.0003 8.66668 11.7018 8.66668 11.3337C8.66668 10.9655 8.3682 10.667 8.00001 10.667C7.63182 10.667 7.33334 10.9655 7.33334 11.3337C7.33334 11.7018 7.63182 12.0003 8.00001 12.0003Z"
                    fill="#B3C2CB"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M8.23738 5.70689C7.91366 5.7211 7.74104 5.85135 7.68129 5.97831C7.5245 6.31145 7.12733 6.45441 6.79419 6.29762C6.46106 6.14083 6.3181 5.74366 6.47489 5.41053C6.82301 4.67086 7.57297 4.40144 8.17892 4.37484C8.7618 4.34926 9.48718 4.53492 9.88849 5.05823C10.1973 5.46093 10.3708 5.9714 10.3007 6.50813C10.2297 7.05237 9.91926 7.54056 9.41556 7.91111C8.74294 8.40594 8.74413 8.65841 8.74431 8.69517C8.74431 8.69571 8.74431 8.6962 8.74431 8.69664C8.74431 9.06483 8.44583 9.36331 8.07764 9.36331C7.70945 9.36331 7.41098 9.06483 7.41098 8.69664C7.41098 8.05884 7.78196 7.45763 8.62545 6.8371C8.88471 6.64637 8.96187 6.46388 8.97862 6.33555C8.99635 6.19971 8.95784 6.03573 8.83044 5.8696C8.82148 5.85791 8.77279 5.80928 8.65086 5.76547C8.53445 5.72363 8.38807 5.70028 8.23738 5.70689Z"
                    fill="#B3C2CB"
                  />
                  <path
                    d="M8 15.3337C3.93334 15.3337 0.666672 12.067 0.666672 8.00033C0.666672 3.93366 3.93334 0.666992 8 0.666992C12.0667 0.666992 15.3333 3.93366 15.3333 8.00033C15.3333 12.067 12.0667 15.3337 8 15.3337ZM8 2.00033C4.66667 2.00033 2.00001 4.66699 2.00001 8.00033C2.00001 11.3337 4.66667 14.0003 8 14.0003C11.3333 14.0003 14 11.3337 14 8.00033C14 4.66699 11.3333 2.00033 8 2.00033Z"
                    fill="#B3C2CB"
                  />
                </svg>
              </span>
              <b-popover
                target="popover-target-1"
                id="popover-target-2"
                triggers="click"
                placement="bottom"
                class="info_popup"
              >
                Shall you be the only one to see it
              </b-popover>
            </p>
          </div>
        </b-form-group>

        <!-- IMAGE  UPLOAD (OPT)-->
        <b-form-group
          v-if="additionalInfo"
          id="fieldset-1"
          description="Add Associated Documents"
          label-for="input-1"
        >
          <img
            v-if="form.imgURL"
            :src="form.imgURL"
            style="height: 150px; border: solid;
            border-width: thin;
             border-radius: 0px;
            object-fit:cover"
            :alt="`${form.task} cover`"
          />
          <image-upload
            v-else
            ref="image-upload"
            :img-upload-idx="idx"
            img-upload-type="photo"
            :storage-path="storagePath"
            :max-image="1"
            :show-edit="true"
            :show-delete="true"
            style="margin-left: 50px; margin-right: 50px;"
            @img-uploaded-url="handleImgUploadedURL"
          />
        </b-form-group>
        <b-form-group
          v-if="false"
          id="fieldset-2"
          label="Enter a Title"
          description="S."
          label-for="input-1"
        >
          <b-form-input
            id="input-1"
            v-model="name"
            :state="state"
            trim
          ></b-form-input>
        </b-form-group>
        <b-icon
          icon="plus-lg"
          title="Additional Ifo"
          variant="primary"
          scale="1"
          @click="handleAdditionalInfoToggle"
          style="cursor:pointer"
        >
        </b-icon>
        <b-link
          style="cursor:pointer;margin-bottom: 25px;"
          @click="handleAdditionalInfoToggle"
        >
          Add More Info
        </b-link>
        <template v-if="additionalInfo"> </template>
        <div style="padding-top: 20px;">
          <button class="btn-add-crew" @click="handleAddToDo">
            Add
          </button>
        </div>
        <b-card v-if="!production" class="mt-3" header="Form Data Result">
          <pre class="m-0">{{ form }}</pre>
        </b-card>
      </b-card>
      <template #footer>
        <div class="d-flex bg-dark text-light align-items-center px-3 py-2">
          <strong class="mr-auto"> </strong>
          13 Total | 3 Assigned
        </div>
      </template>
      <div></div>
    </b-sidebar>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import moment from "moment";
import UploadImage from "@/mixins/UploadImage";
import ImageUpload from "@/components/common/imageUpload";
import Editor from "@/components/common/editor";
export default {
  name: "ToDo_Form",
  mixins: [UploadImage],
  components: {
    ImageUpload,
    Editor,
  },
  props: {
    sbId: {
      type: String,
      required: true
    },
    items: {
      type: Array,
      default: () => [],
      required: false
    },
    assetsUrlHome: {
      type: String,
      default: "",
      required: false
    },
    updatedAt: {
      type: String,
      default: "",
      required: false
    }
  },
  created() {},
  mounted() {
    this.form = this.defaultForm; //@TODO do I task to deepclone ?

    this.form._created_at = new Date();
    let createdBy = this.form._created_by;
    createdBy.uid = this.user.uid ? this.user.uid : null;
    createdBy.name = `${this.profile.firstname} ${this.profile.lastname}`;
    createdBy.imgURL = this.profile.imgURL;
    createdBy.relation = "Uncle";
  },
  computed: {
    ...mapGetters({
      user: "user/user",
      familyActive: "user/familyActive",
      profile: "user/profile",
      apps: "user/apps",
      userData: "user/appsData"
    }),
    /**** Validations ****/
    state() {
      return true;
      return this.form.task.length >= 10;
    },
    invalidFeedback() {
      if (this.form.task.length > 0) {
        return "Enter at least 4 characters.";
      }
      return "Please enter something.";
    },
    titleDate() {
      return "Add A Task";
    }
  },
  methods: {
    addTag(newTag) {
      this.form.tags.unshift(newTag);
      this.formInputAddTag = "";
    },
    delTag(tag) {
      let index = this.form.tags.indexOf(tag);
      if (index > -1) {
        this.form.tags.splice(index, 1);
      }
    },
    handleToggleHasReminder() {
      this.form.hasReminder = !this.form.hasReminder;
    },
    handleToggleIsRecurring() {
      this.form.isRecurring = !this.form.isRecurring;
    },
    handleToggleIsPrivate() {
      this.form.isPrivate = !this.form.isPrivate;
    },
    handleToggleNeedAVolunteer() {
      this.form.needVolunteer = !this.form.needVolunteer;
    },
    handleOpenFormSideBar() {
      this.formSBModel = true;
    },
    handleFamilyMemberClick() {
      if (member) {
        //family clicked- add to array
        let userId =
          member.user && member.user.userId ? member.user.userId : null;
        if (userId) {
          if (!this.volunteers.includes(userId)) {
            this.volunteers.push(member.user.userId);
          } else {
            this.volunteers = this.volunteers.filter(aV => aV != userId);
          }
        }
      } else {
        //clear array
        this.volunteers = [];
      }
    },
    /**/
    handleAdditionalInfoToggle() {
      this.additionalInfo = !this.additionalInfo;
    },
    handleImgUploadedURL(idx, url) {
      this.form.imgURL = url;
      this.form.docs.push(url);
    },
    resetForm() {
      this.form = this.defaultForm;
    },
    input(val) {
      this.form.description = val.content;
    },
    handleAddToDo() {
      this.form.status =
        this.volunteers && this.volunteers.length === 0
          ? `needs_help`
          : `not_started`;
      this.$emit("add-todo-click", this.form);
      this.resetForm();
      this.handleCloseSideBar();
    },
    handleOpenSideBar() {
      this.sidebarModel = true;
    },
    handleCloseSideBar() {
      this.formSBModel = false;
    },
    resetClear() {
      this.clear = false;
    }
  },
  data() {
    return {
      formInputAddTag: null,
      production: true,
      formSBModel: false,
      form: {},
      defaultForm: {
        _created_at: null, //To be set when used
        _started_at: null, //To be set when used
        needVolunteer: false,
        hasReminder: false,
        isRecurring: false,
        isPrivate: false,
        priority: null,
        size: null,
        tags: [],
        task: null,
        title: "",
        dueDate: null,
        description: [],
        imgURL: "",
        _created_by: {
          uid: "",
          name: "",
          imgURL: "",
          relation: ""
        }
      },
      priorityOpt: [
        {
          value: "urgent",
          text: "Urgent",
          color: "red",
          _created_at: 1234
        },
        {
          value: "high",
          text: "High",
          _created_at: 1234
        },
        {
          value: "medium",
          text: "Medium",
          _created_at: 1234
        },
        {
          value: "low",
          text: "Low",
          _created_at: 1234
        }
      ],
      sizeOpt: [
        {
          value: "xl",
          text: "XL",
          color: "red",
          _created_at: 1234
        },
        {
          value: "l",
          text: "Large",
          _created_at: 1234
        },
        {
          value: "m",
          text: "Med",
          _created_at: 1234
        },
        {
          value: "s",
          text: "Small",
          _created_at: 1234
        },
        {
          value: "xs",
          text: "XS",
          _created_at: 1234
        }
      ],
      volunteerNeeded: {
        nickname: "Need A Volunteer"
      },
      volunteers: [],
      additionalInfo: false,
      idx: 0,
      docs: [],
      storagePath: "app_todo_images",
      clear: false,
      status: "not_started", //needs_help | not_started | started | done
      /* SLIDE INFO*/
      mainProps: {
        blank: false,
        blankColor: "#777",
        width: 75,
        height: 75,
        class: "m1"
      }
    };
  }
};
</script>

<style lang="scss" scoped>
.family-card {
  cursor: pointer;
  &.selected {
    background-color: #f8c22f;
  }
}

.optional2 {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  flex-wrap: wrap;
  p {
    margin-left: 16px;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    display: flex;
    align-items: center;
    color: #474d52;
    margin: 0;
    margin-left: 16px;
    span {
      padding-left: 8px;
    }
  }
}
.toggler {
  position: relative;
  display: inline-block;
  width: 46.5px;
  height: 24px;
  background: #f3f6f9;
  border-radius: 18px;
  -webkit-transition: 0.4s;
  transition: 0.4s;
  cursor: pointer;
  @media (max-width: 590px) {
    margin-left: 15px;
  }
}
.slider {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 3px;
  bottom: 3px;
  background: #b3c2cb;
  box-shadow: 0px 3px 9px #c4c4c4;

  -webkit-transition: 0.4s;
  transition: 0.4s;
  border-radius: 50%;
}
.bg {
  background: rgba(85, 126, 251, 0.1);
}
.btns {
  left: 50%;
  background: var(--theme-color);
  box-shadow: 0px 3px 9px rgba(85, 126, 251, 0.24);
}

.family-opacity {
  opacity: 0.3;
}
</style>
